document.addEventListener("DOMContentLoaded", () => {
  const galleries = document.querySelectorAll('.wp-block-ncst-thumbnail-gallery');

  galleries.forEach((gallery) => {
    const grid = gallery.querySelector('.thumbnail-grid');
    const images = Array.from(grid.querySelectorAll('button.thumbnail'));
    const button = gallery.querySelector('.view-more-images .btn');
    const remaining = JSON.parse(gallery.dataset.remaining || '[]');

    // Lightbox setup
    let currentIndex = 0;
    let lastFocusedTrigger = null;

    // Use the same ordering as your thumbnail buttons
    const lightboxItems = images.map((btn) => {
      const img = btn.querySelector('img');
      return {
        trigger: btn,
        fullUrl: btn.dataset.fullUrl || img?.dataset.fullUrl,
        caption: btn.dataset.caption || img?.dataset.caption || "",
        alt: img?.getAttribute('alt') || ""
      };
    });

    let overlay = null;
    let lightboxImg = null;
    let lightboxCaption = null;
    let closeBtn = null;
    let prevBtn = null;
    let nextBtn = null;

    const updateImage = () => {
      const item = lightboxItems[currentIndex];
      if (!item) return;

      lightboxImg.src = item.fullUrl || "";
      // Prefer explicit alt, then caption, then generic
      const altText = item.alt || item.caption || "Expanded image";
      lightboxImg.alt = altText;
      lightboxCaption.textContent = item.caption;
    };

    const trapFocus = (e) => {
      const focusable = overlay.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };

    const onKeyDown = (e) => {
      if (!overlay || overlay.getAttribute('aria-hidden') === 'true') return;

      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        closeLightbox();
        return;
      }

      if (e.key === 'ArrowRight') {
        e.preventDefault();
        currentIndex = (currentIndex + 1) % lightboxItems.length;
        updateImage();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        currentIndex = (currentIndex - 1 + lightboxItems.length) % lightboxItems.length;
        updateImage();
      } else if (e.key === 'Tab') {
        trapFocus(e);
      }
    };

    const openLightbox = (index, trigger) => {
      currentIndex = index;
      lastFocusedTrigger = trigger;

      // Create overlay once per gallery
      if (!overlay) {
        overlay = document.createElement("div");
        overlay.className = "lightbox-overlay";
        overlay.setAttribute('role', 'dialog');
        overlay.setAttribute('aria-modal', 'true');
        overlay.setAttribute('aria-hidden', 'true');
        overlay.setAttribute('aria-labelledby', 'lightbox-heading');

        overlay.innerHTML = `
          <div class="lightbox-controls">
            <button id="prev" type="button" aria-label="Previous image">
              <svg class="wolficon" aria-hidden="true">
                <use xlink:href="#wolficon-arrow-left-bold"></use>
              </svg>
            </button>
            <button id="next" type="button" aria-label="Next image">
              <svg class="wolficon" aria-hidden="true">
                <use xlink:href="#wolficon-arrow-right-bold"></use>
              </svg>
            </button>
          </div>
          <header class="lightbox-header">
            <h2 id="lightbox-heading" class="sr-only">Image viewer</h2>
          </header>
          <div class="lightbox-inner" role="document">
            <div class="lightbox-content">
              <figure>
                <img id="lightbox-image" />
                <figcaption id="lightbox-caption" class="lightbox-caption"></figcaption>
              </figure>
            </div>
          </div>
          <button type="button" id="lightbox-close">
            <span class="sr-only">Close image viewer</span>
            <svg aria-hidden="true" viewBox="0 0 32 32"><path d="M17.414 16 26 7.414 24.586 6 16 14.586 7.414 6 6 7.414 14.586 16 6 24.586 7.414 26 16 17.414 24.586 26 26 24.586 17.414 16z"></path></svg>
          </button>
        `;

        document.body.appendChild(overlay);

        lightboxImg = overlay.querySelector("#lightbox-image");
        lightboxCaption = overlay.querySelector("#lightbox-caption");
        closeBtn = overlay.querySelector("#lightbox-close");
        prevBtn = overlay.querySelector("#prev");
        nextBtn = overlay.querySelector("#next");

        // Click handlers
        prevBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          currentIndex = (currentIndex - 1 + lightboxItems.length) % lightboxItems.length;
          updateImage();
        });

        nextBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          currentIndex = (currentIndex + 1) % lightboxItems.length;
          updateImage();
        });

        closeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          closeLightbox();
        });
      }

      // Show and configure modal state
      overlay.setAttribute('aria-hidden', 'false');
      document.getElementsByTagName( 'html' )[0].classList.add("ncstate-utility-bar-lock-scroll");

      updateImage();

      // Move focus into dialog (close button first)
      closeBtn.focus();

      // Global key handling while open
      document.addEventListener('keydown', onKeyDown);
    };

    const closeLightbox = () => {
      if (!overlay) return;

      overlay.setAttribute('aria-hidden', 'true');
      document.getElementsByTagName( 'html' )[0].classList.remove("ncstate-utility-bar-lock-scroll");
      document.removeEventListener('keydown', onKeyDown);

      // Return focus to the trigger thumbnail
      if (lastFocusedTrigger) {
        lastFocusedTrigger.focus();
      }
    };

    if ( button ) {
      button.addEventListener('click', (e) => {
        let indexOffset = Number(gallery.dataset.initial); // uses $initial_count as offset from index.php
        const fragment = document.createDocumentFragment();
        let firstNewItem = null;

        remaining.forEach((img, index) => {
          const wrapper = document.createElement('button');
          wrapper.className = 'thumbnail';
          wrapper.type = 'button';
          wrapper.role = 'listitem';
          wrapper.setAttribute('aria-haspopup', 'dialog');
          wrapper.setAttribute('aria-label', img.caption || img.alt || 'Open full size image');
          wrapper.dataset.index = index + indexOffset;

          const image = document.createElement('img');
          image.src = img.url;
          image.alt = img.alt || '';
          image.loading = 'lazy';
          image.dataset.fullUrl = img.fullUrl || img.url || '';
          image.dataset.caption = img.caption || '';

          wrapper.appendChild(image);
          fragment.appendChild(wrapper);

          // Add to lightbox items array
          const newItemIndex = lightboxItems.length;
          lightboxItems.push({
            trigger: wrapper,
            fullUrl: image.dataset.fullUrl,
            caption: image.dataset.caption,
            alt: image.alt || ""
          });

          // Attach lightbox click handler
          wrapper.addEventListener("click", () => {
            openLightbox(newItemIndex, wrapper);
          });

          // Attach keyboard handler
          wrapper.addEventListener("keydown", (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              openLightbox(newItemIndex, wrapper);
            }
          });


          if (index === 0) {
            firstNewItem = wrapper;
          }
        });

        grid.appendChild(fragment);

        // remove clunky data
        delete gallery.dataset.remaining;
        const viewMoreButton = button.closest('.wp-block-ncst-buttons.view-more-images');
        if (viewMoreButton) {
          viewMoreButton.remove();
        }

        // Move focus to first newly added image
        if (firstNewItem) {
          firstNewItem.focus({ preventScroll: false });
        }
      });
    }
    


    // Wire thumbnails: open lightbox via click or keyboard (enter/space)
    images.forEach((btn, index) => {
      btn.addEventListener("click", () => {
        openLightbox(index, btn);
      });

      btn.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          openLightbox(index, btn);
        }
      });
    });
  });
});
